import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'pw-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  @HostBinding('style.gridTemplateColumns')
  @Input()
  public gridTemplateColumns: string;
}
